// extracted by mini-css-extract-plugin
export var fadeInOut = "_1j-3";
export var icon = "_1j-4";
export var savedIndicator = "_1j-2";
export var savingIndicator = "_1j-0";
export var spin = "_1j-1";